<template>
	<div>
		<v-layout wrap ma-4>
			<v-flex xs12>
				<BaseInput :height="35" label="Nombre de Plan de Cuentas" v-model="model.description" required>
					<span slot="error" class="caption error--text" v-if="$v.model.description.$invalid">
						El nombre es requerido
					</span>
				</BaseInput>
			</v-flex>
			<v-flex xs12 mt-3>
				<BaseInput :height="35" label="Año Contable" v-model="model.year">
					<span slot="error" class="form-group__message error--text" v-if="!$v.model.year.required">
						El año requerido
					</span>
					<span slot="error" class="form-group__message error--text" v-if="!$v.model.year.between">
						El Año debe tener cuatro dígitos
					</span>
				</BaseInput>
			</v-flex>
			<v-layout row wrap mt-2 v-if="!idAccount">
    <!-- Opción 1: Cargar plan personalizado -->
    <v-flex xs12>
    <div class="custom-title">
  <span class="exclamation">¡</span>
  ELIGE AQUÍ TIPO DE PLAN CONTABLE
  <span class="exclamation">!</span>
</div>
</v-flex>
  <v-flex xs12  class="text-xs-center layout align-center justify-center" >
	 <button class="modern-import-option" @click="dialog = true" :disabled="!model.description && !model.year">
                  <img src="/static/img/actions-list/excel.svg" alt="importar excel">
                  <span class="import-text">  ELIGIR EL TIPO DE PLAN CONTABLE</span>
                </button>
    </v-flex>
  </v-layout>
			<v-dialog v-model="dialog" persistent max-width="650">
  <v-card style="border-radius: 15px; box-shadow: 0 8px 32px rgba(0,0,0,0.12);">
     <div v-if="loadingAccount" class="loading-overlay">
      <div class="loading-content">
        <div class="modern-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <div class="loading-text">
          <h3>Guardando Plan de Cuentas</h3>
          <p>Por favor espera mientras procesamos tu información...</p>
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <v-card-title class="modern-title">
      <span class="title-text">Plan de Cuentas</span>
      <v-spacer></v-spacer>
      <v-icon color="primary" size="28">account_balance</v-icon>
    </v-card-title>
    
    <v-card-text class="pb-2">
      <v-layout row wrap>
        <!-- Selector de opción modernizado -->
        <v-flex xs12>
          <div class="modern-radio-container">
            <div class="radio-option-card" 
                 :class="{ 'active': loadOption === 'default' }"
                 @click="loadOption = 'default'">
              <div class="radio-content">
                <div class="radio-circle">
                  <div class="radio-dot" v-if="loadOption === 'default'"></div>
                </div>
                <div class="radio-text">
                  <div class="radio-title">Cargar Plan de Cuentas (Predeterminado, configuracion automática)</div>
                  <div class="radio-subtitle">Usar plantilla predeterminada(Sin ningun costo adicional)</div>
                </div>
              </div>
              <v-icon class="radio-icon" :color="loadOption === 'default' ? 'primary' : 'grey'">
                cloud_download
              </v-icon>
            </div>
            
            <div class="radio-option-card" 
                 :class="{ 'active': loadOption === 'custom' }"
                 @click="loadOption = 'custom'">
              <div class="radio-content">
                <div class="radio-circle">
                  <div class="radio-dot" v-if="loadOption === 'custom'"></div>
                </div>
                <div class="radio-text">
                  <div class="radio-title">Cargar tu propio plan contable</div>
                  <div class="radio-subtitle">Importar archivo personalizado (Esta opción tiene un recargo adicional por configuración especial de soporte.)</div>
                </div>
              </div>
              <v-icon class="radio-icon" :color="loadOption === 'custom' ? 'primary' : 'grey'">
                upload_file
              </v-icon>
            </div>
          </div>
        </v-flex>

        <!-- Primer bloque: Botón "Cargar Plan de Cuentas" -->
        <v-flex xs12  mt-1 v-if="loadOption === 'default' && !idAccount">
			 <v-flex xs12 class="container-import modern-import-container" mt-3>
				<div class="d-flex justify-center">
				<v-btn 
				color="success"
				:disabled="loadingAccount"
				class="white--text modern-btn elevation-3"
				@click="automaticSavePlan"
				download="plantilla_cuentas_contables.xlsx">
				 <template v-if="!loadingAccount">
					<v-icon left>cached</v-icon>
					Cargar Automáticamente Plan Contable 
					</template>
					<template v-else>
					<div class="btn-spinner"></div>
					Guardando...
					</template>
				</v-btn>
				</div>
			</v-flex>
        </v-flex>

        <!-- Segundo bloque: BaseInput y botón de importar -->
        <v-flex xs12 v-if="loadOption === 'custom'">
          <v-layout row wrap>
			
            <v-flex xs12 class="container-import modern-import-container" mt-3>
				<v-flex xs12 v-if="!idAccount">
          <label ref="label" for="download-excel">
            <vue-six-four ref="vueSixFour" id="download-excel" hidden @vue-six-four="getFile" />
            <v-layout>
              <v-flex xs12>
                <div class="d-flex justify-center">
                  <v-btn 
                    color="success" 
                    class="white--text modern-btn elevation-3"
                    href="https://motor-bucket1.s3.us-east-1.amazonaws.com/motor-bucket1/PLAN_MODELO+(1).xlsx"
                    download="plantilla_cuentas_contables.xlsx">
                    <v-icon left>file_download</v-icon>
                    Descargar Plantilla
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </label>
        </v-flex>
              <div class="import-wrapper">
                <BaseInput 
                  :height="40" 
                  label="Adjuntar excel" 
                  v-model="excelName" 
                  required 
                  class="modern-input">
                </BaseInput>
                <button class="modern-import-btn" @click="showDialog">
                  <img src="/static/img/actions-list/excel.svg" alt="importar excel">
                  <span class="import-text">Importar</span>
                </button>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Tabla modernizada -->
		  <v-flex xs12 v-if="rows.length > 0 && automaticSavePlanFlag" class="mt-4">
          <div class="modern-table-container">
            <app-table
              class="is-not-selectable modern-table" 
              name="accounts-list-validate" 
              :input-search="false" 
              :filter-columns="false" 
              :columns="columns" 
              :rows="rows" 
              :main-list="false">
              <template slot="rows" slot-scope="props">
                <td v-show="showRow(columns, 1)">{{ props.row.name }}</td>
                <td v-show="showRow(columns, 2)">{{ props.row.account }}</td>
                <td v-show="showRow(columns, 3)">{{ props.row.code }}</td>
                <td v-show="showRow(columns, 4)">{{ props.row.fatherAccount }}</td>
                <td v-show="showRow(columns, 5)">{{ props.row.level }}</td>
                <td v-show="showRow(columns, 6)">{{ props.row.status === false ? '0' : '1' }}</td>
              </template>
            </app-table>
          </div>
        </v-flex>
            <v-flex xs12 v-if="massageError && massageError.length > 0" class="mt-4">
          <div class="error-container">
            <div class="error-header">
              <v-icon color="error" class="error-icon">error_outline</v-icon>
              <h4 class="error-title">Errores encontrados ({{ massageError.length }})</h4>
            </div>
            
            <div class="error-list-container">
              <transition-group name="error-list" tag="div" class="error-list">
                <div 
                  v-for="errorItem in massageError" 
                  :key="errorItem.id"
                  class="error-item"
                >
                  <div class="error-content">
                    <div class="error-number">{{ errorItem.index + 1 }}</div>
                    <div class="error-message">
                      <v-icon size="16" color="error" class="error-bullet">fiber_manual_record</v-icon>
                      <span class="error-text">{{ errorItem.message }}</span>
                    </div>
                  </div>
                  <v-icon color="error" size="20" class="error-warning">warning</v-icon>
                </div>
              </transition-group>
            </div>
            
            <div class="error-footer">
              <v-btn 
                small 
                color="error" 
                outlined 
                @click="clearErrors"
                class="clear-errors-btn">
                <v-icon left small>clear_all</v-icon>
                Limpiar errores
              </v-btn>
              <span class="error-help-text">
                Corrige estos errores antes de continuar
              </span>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    
    <!-- Botones modernizados -->
    <v-card-actions class="modern-actions">
      <v-btn 
        class="modern-action-btn cancel-btn" 
        color="error"
        :disabled="loadingAccount" 
        @click="closeDialog">
        <v-icon left>close</v-icon>
        Cancelar
      </v-btn>
      
      <v-btn 
        v-if="loadOption === 'custom'" 
        class="modern-action-btn validate-btn"
        :disabled="!model.base64 || loadingAccount" 
        color="success" 
        @click="validateExcel(false)">
        <v-icon left>check_circle</v-icon>
        Validar
      </v-btn>
      
      <v-btn 
        class="modern-action-btn save-btn"
		v-if="loadOption === 'custom'"
        :disabled="$v.$invalid || disableSaveButton || rows.length <= 0" 
        color="blue" 
        @click="sendAccount(false)">
         <template v-if="!loadingAccount">
          <v-icon left>save</v-icon>
          Guardar
        </template>
        <template v-else>
          <div class="btn-spinner"></div>
          Guardando...
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button success-text="Aceptar" :hiddenSaveBtn="!idAccount" @cancel-button-clicked="closeModal"
				@accept-button-clicked="sendAccount" :is-loading="$v.$invalid || disableSaveButton">
			</modal-sidebar-button>
		</section>
	</div>
</template>

<script>
import VueSixFour from 'vue-six-four';
import { required, between, requiredIf } from 'vuelidate/lib/validators';

function closeModal() {
	this.goTo('accounting-plans', { params: { subsidiaryId: this.subsidiaryId } });
}

function getFile(fileInfo) {
	console.log('fileInfo::: ', fileInfo);
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
	this.rows = [];
}

async function getFileAutomatic() {
	const excelUrl = `${process.env.EXCEL_EXPORT}/documents/pc-quipu.xlsx`.replace(/\/\//g, '/');
	try {
		// 1. Primero verifica que el archivo exista
		const check = await fetch(excelUrl, { method: 'HEAD' });
		if (!check.ok) {
			this.showGenericError('Archivo no encontrado en el servidor');
		}
		// 2. Hacer una nueva solicitud GET para obtener el contenido
		const response = await fetch(excelUrl);
		if (!response.ok) {
			this.showGenericError(`Error ${response.status}`);
		}
		// 3. Obtener el Blob correctamente
		const blob = await response.blob();
		// 4. Convertir a Base64
		const base64 = await this.convertBlobToBase64(blob);
		this.model.base64 = base64;
		this.validateExcel(true);
	} catch (error) {
		this.showGenericError();
	}
}

// Función mejorada para conversión
function convertBlobToBase64(blob) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const result = reader.result;
			if (!result) {
				this.showGenericError('La lectura del blob falló');
			}
			// Extrae solo la parte Base64 (después de la coma)
			const base64Data = result.split(',')[1];
			resolve(base64Data || result); // Fallback si no hay coma
		};
		reader.onerror = () => reject(reader.error);
		reader.readAsDataURL(blob);
	});
}

function closeDialog() {
	this.rows = [];
	this.model.base64 = null;
	this.massageError = null;
	this.dialog = false;
	this.excelName = null;
}

async function loadAccounting() {
	const { data: response } = await this.$http.get(`com-accounting-plan-details/${this.idAccount}`);
	this.model = {
		description: response.description,
		year: response.year,
		code: response.code,
	};
}

async function automaticSavePlan() {
	this.automaticSavePlanFlag = true;
	this.getFileAutomatic();
}


async function validateExcel(aut = false) {
	console.log('aut::: ', aut);
	this.model.subsidiaryId = this.subsidiaryId;
	if (!aut) {
		delete this.model.dateArchive;
		try {
			this.loadingAccount = true;
			this.massageError = []; // Limpiar errores previos
			this.rows = []; // Limpiar datos previos
			const { data: response } = await this.$http.post('com-accounting-plan-validate-excel', this.model);
			this.rows = response;
			this.automaticSavePlanFlag = true;
			console.log('this.rows::: ', this.rows);
			this.showNotification('Cuentas contables validadas correctamente');
		} catch (error) {
			if (error.status === 400) {
				/* eslint-disable */
				const splittedErrors = error.data.message.split('Fila ');
			this.massageError = splittedErrors
				.map((msg, idx) => idx === 0 ? msg : 'Fila ' + msg)
				.filter(msg => msg.trim() !== '')
				.map((error, index) => ({
					id: Number(`${Date.now()}-${index}`),
					message: error,
					index: index,
					timestamp: Date.now() + index
			}));
			console.log('Errores procesados:', this.massageError);
				/* eslint-enable */
				this.showGenericError('Ups, algo salió mal. Verifique los errores');
			} else {
				this.showGenericError('Error al validar el archivo');
			}
		} finally {
			this.loadingAccount = false;
		}
	} else {
		delete this.model.dateArchive;
		try {
			this.loadingAccount = true;
			this.massageError = []; // Limpiar errores previos
			this.rows = []; // Limpiar datos previos
			this.flagAutomatic = true;
			const { data: response } = await this.$http.post('com-accounting-plan-validate-excel', this.model);
			this.rows = response;
			this.showNotification('Cuentas contables validadas correctamente');
			await this.sendAccount(true);
		} catch (error) {
			if (error.status === 400) {
				/* eslint-disable */
				const splittedErrors = error.data.message.split('Fila ');
				this.massageError = splittedErrors
					.map((msg, idx) => idx === 0 ? msg : 'Fila ' + msg)
					.filter(msg => msg.trim() !== '');
				/* eslint-enable */
				this.showGenericError('Ups, algo salió mal. Verifique los errores');
			} else {
				this.showGenericError('Error al validar el archivo');
			}
		}
	}
}

function mounted() {
	if (this.idAccount) {
		this.loadAccounting();
	}
}

async function sendAccount(val = false) {
	if (val) {
		delete this.model.base64;
		if (!this.idAccount) {
			this.model.dateArchive = this.rows;
		}
		this.$emit('update-account', this.model, this.idAccount, true);
		setTimeout(() => {
			this.loadingAccount = false;
		}, 10000);
		this.automaticSavePlanFlag = false;
	} else {
		this.loadingAccount = true;
		delete this.model.base64;
		if (!this.idAccount) {
			this.model.dateArchive = this.rows;
		}
		this.$emit('update-account', this.model, this.idAccount, false);
		this.loadingAccount = false;
	}
}

function showDialog() {
	console.log('this.$refs::: ', this.$refs);
	this.$refs.label.click();
}

function clearErrors() {
	this.massageError = [];
}

function validations() {
	const validation = {
		model: {
			base64: {
				required: requiredIf(() => !this.idAccount),
			},
			description: {
				required,
			},
			year: {
				required,
				between: between(999, 9999),
			},
		},
	};
	return validation;
}

function data() {
	return {
		excelName: null,
		columns: [
			{ id: 1, name: 'Name', checked: true, visible: true },
			{ id: 2, name: 'Cuenta', checked: true, visible: true },
			{ id: 3, name: 'Código', checked: true, visible: true },
			{ id: 4, name: 'Padre', checked: true, visible: true },
			{ id: 5, name: 'Level', checked: true, visible: true, flagVisible: true },
			{ id: 6, name: 'Estado', checked: true, visible: true, flagVisible: true },
		],
		model: {
			base64: null,
			code: null,
			description: null,
			year: null,
		},
		rows: [],
		automaticSavePlanFlag: false,
		loadOption: 'default',
		dialog: false,
		loadingAccount: false,
		flagAutomatic: false,
		massageError: null,
	};
}

export default {
	name: 'accounting-edit',
	components: {
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		VueSixFour,
	},
	data,
	mounted,
	methods: {
		closeModal,
		closeDialog,
		getFile,
		getFileAutomatic,
		convertBlobToBase64,
		loadAccounting,
		automaticSavePlan,
		validateExcel,
		clearErrors,
		sendAccount,
		showDialog,
	},
	props: {
		idAccount: [String, Number],
		subsidiaryId: [String, Number],
		disableSaveButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>
	.download-btn {
		background-color: color(btn-green);
		border-radius: 100px;
		color: white;
		font-size: size(small);
		height: 38px !important;
		padding: 10px 15px;
		text-align: center;
		text-decoration: none;
		width: 150px;
	}

	.upload-field {
		position: relative;
	}

	.btn-upload {
		align-items: center;
		background-color: color(secondary);
		border-bottom-right-radius: 50px;
		border-top-right-radius: 50px;
		display: flex;
		height: 38px !important;
		padding: 0 13px !important;
		position: absolute;
		right: -8px;
		top: 0;
	}
	.container-import {
		position: relative;

		.btn-import {
			background: #03A89E;
			border-radius: 0 5px 5px 0;
			height: 35px;
			padding: 5px 7px 5px 0;
			position: absolute;
			right: 0;
			top: 16px;
			width: 51px;
		}
	}


.info-row {
  background-color: #d9edf7; /* Fondo informativo (azul claro) */
  color: #31708f;           /* Color de texto informativo */
  padding: 5px;
  margin-bottom: 5px;
}

.warning-row {
  background-color: #fcf8e3; /* Fondo amarillo (advertencia) */
  color: #8a6d3b;           /* Color de texto para advertencia */
  padding: 5px;
  margin-bottom: 5px;
}

.btn-green {
	background: map-get($colors, green-icon);
	border-radius: 100px;
	color: map-get($colors, white);
	display: block;
	font-size: 14px;
	height: 38px;
	padding: 8px;
	text-align: center;
	text-decoration: none;
	width: 100%;
}
.custom-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: color(blue-icon);
  font-family: font(AvenirDemi);
  text-align: center;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.exclamation {
  color: #03A89E; /* Color corporativo si lo tienes */
  font-size: 1.8rem;
  font-weight: 900;
  animation: bounce 1s infinite alternate;
}

@keyframes bounce {
  from { transform: translateY(0) scale(1.2); }
  to { transform: translateY(-5px) scale(1.3); }
}

/* Estilo para los chips */

.modern-title {
  background: linear-gradient(135deg, #03C4B4 0%, #03C4B4 70%);
  border-radius: 15px 15px 0 0;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: white;
}

.title-text {
  font-size: 1.4rem;
  font-weight: 600;
  color: white;
}

/* Container de radio buttons modernos */
.modern-radio-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

/* Tarjetas de opción */
.radio-option-card {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.radio-option-card:hover {
  border-color: #03A89E;
  background: #f8f9ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.radio-option-card.active {
  border-color: #03A89E;
  background: linear-gradient(135deg, #f1fcfb 0%, #d2f1ee 100%);
  box-shadow: 0 4px 12px rgba(3, 168, 158, 0.15);
}


/* Contenido del radio */
.radio-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Círculo del radio personalizado */
.radio-circle {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
}

.radio-option-card.active .radio-circle {
  border-color: #03A89E;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.radio-dot {
  width: 10px;
  height: 10px;
  background: #03A89E;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: radioScale 0.3s ease;
}
.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes radioScale {
  0% { transform: translate(-50%, -50%) scale(0); }
  100% { transform: translate(-50%, -50%) scale(1); }
}

/* Texto del radio */
.radio-text {
  display: flex;
  flex-direction: column;
}

.radio-title {
  font-weight: 600;
  font-size: 1rem;
  color: #2c3e50;
  margin-bottom: 2px;
}

.radio-subtitle {
  font-size: 0.85rem;
  color: #7f8c8d;
}

.radio-icon {
  font-size: 24px !important;
}

/* Botones modernizados */
.modern-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 44px !important;
}

/* Container de importación */
.modern-import-container {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e9ecef;
}

.import-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modern-input {
  flex: 1;
}

.modern-import-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  height: 40px;
}

.modern-import-option {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  height: 40px;
}
.modern-import-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.modern-import-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.import-text {
  font-size: 0.9rem;
  font-weight: 600;
}

/* Tabla modernizada */
.modern-table-container {
  max-height: 250px;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: white;
}

.modern-table {
  border-radius: 12px;
}

/* Acciones modernizadas */
.modern-actions {
  padding: 20px 24px !important;
  background: #f8f9fa;
  border-radius: 0 0 15px 15px;
  display: flex !important;
  justify-content: center !important;
  gap: 12px !important;
}

.modern-action-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 44px !important;
  color: white !important;
}

.cancel-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
}

.validate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 15px;
}

.loading-content {
  text-align: center;
  padding: 40px;
}

/* Spinner moderno */
.modern-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: #2196F3;
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  border-right-color: #4CAF50;
  animation-delay: -0.5s;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
}

.spinner-ring:nth-child(3) {
  border-bottom-color: #FF9800;
  animation-delay: -1s;
  width: 40%;
  height: 40%;
  top: 30%;
  left: 30%;
}

/* Texto de loading */
.loading-text h3 {
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.loading-text p {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 20px;
}

/* Puntos animados */
.loading-dots {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background: #2196F3;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}
.error-container {
  background: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%);
  border: 1px solid #ffcdd2;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.1);
}

.error-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ffcdd2;
}

.error-icon {
  margin-right: 12px;
  font-size: 24px !important;
}

.error-title {
  color: #c62828;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

/* LISTA DE ERRORES */
.error-list-container {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 16px;
}

.error-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.error-item {
  background: white;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
  animation: slideInError 0.5s ease;
}

.error-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15);
  border-color: #f44336;
}

.error-item-delayed {
  animation-delay: 0.1s;
}

.error-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.error-number {
  background: #f44336;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}

.error-message {
  display: flex;
  align-items: center;
  flex: 1;
}

.error-bullet {
  margin-right: 8px;
}

.error-text {
  color: #c62828;
  font-size: 0.9rem;
  line-height: 1.4;
}

.error-warning {
  margin-left: 12px;
  flex-shrink: 0;
}

/* FOOTER DE ERRORES */
.error-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid #ffcdd2;
}

.clear-errors-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  color: white !important;
}

.error-help-text {
  color: #c62828;
  font-size: 0.85rem;
  font-style: italic;
}

/* ANIMACIONES DE TRANSICIÓN */
.error-list-enter-active,
.error-list-leave-active {
  transition: all 0.5s ease;
}

.error-list-enter-from,
.error-list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.error-list-leave-active {
  position: absolute;
  width: 100%;
}
.loading-dots span:nth-child(1) { animation-delay: -0.32s; }
.loading-dots span:nth-child(2) { animation-delay: -0.16s; }
.loading-dots span:nth-child(3) { animation-delay: 0s; }
/* Responsive */
@media (max-width: 600px) {
  .modern-radio-container {
    gap: 8px;
  }
  
  .radio-option-card {
    padding: 12px;
  }
  
  .modern-actions {
    flex-direction: column !important;
    gap: 8px !important;
  }
  
  .modern-action-btn {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/accounting-plans/accounting-edit.vue